import enScreening from './en/screening.json';
import esScreening from './es/screening.json';

const translations = {
  en: {
    screening: enScreening
  },
  es: {
    screening: esScreening
  }
};

/**
 * Get a translation value by key path
 * @param {string} language - 'en' or 'es'
 * @param {string} namespace - e.g., 'screening'
 * @param {string} key - dot-separated path, e.g., 'form.title'
 * @param {object} params - optional parameters for interpolation
 * @returns {string} - the translated string
 */
export const getTranslation = (language, namespace, key, params = {}) => {
  const lang = translations[language] || translations.en;
  const ns = lang[namespace];
  
  if (!ns) {
    console.warn(`Translation namespace not found: ${namespace}`);
    return key;
  }
  
  // Navigate to the nested key
  const keys = key.split('.');
  let value = ns;
  
  for (const k of keys) {
    if (value && typeof value === 'object' && k in value) {
      value = value[k];
    } else {
      console.warn(`Translation key not found: ${namespace}.${key}`);
      return key;
    }
  }
  
  if (typeof value !== 'string') {
    return key;
  }
  
  // Simple interpolation: replace {{param}} with params.param
  let result = value;
  Object.keys(params).forEach(param => {
    result = result.replace(new RegExp(`{{${param}}}`, 'g'), params[param]);
  });
  
  return result;
};

/**
 * Hook-friendly translation function creator
 * @param {string} language - current language
 * @param {string} namespace - translation namespace
 * @returns {function} - t function for translations
 */
export const createT = (language, namespace = 'screening') => {
  return (key, params = {}) => getTranslation(language, namespace, key, params);
};

export default translations;
